import React from 'react';
import { Box, Divider } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import ReceiptIcon from '@mui/icons-material/Receipt';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import RefreshIcon from '@mui/icons-material/Refresh';
import PhoneIcon from '@mui/icons-material/Phone';
import {
  MapViewMainContainer,
  MapViewSupportHeader,
  MapViewSupportList,
  MapViewSupportItem,
  MapViewIntegratedOrderDetails,
  MapViewOrderDetailsTitle,
  MapViewOrderDetailsContainer,
  OrderInfoRow,
  OrderInfoLabel,
  OrderInfoValue,
  ClosedIconBox,
  ClosedTitle,
  ClosedStatusCard,
  ClosedStatusLabel,
  ClosedStatusText,
  ClosedSupportCard,
  ClosedSupportTitle,
  ClosedSupportDescription,
  ClosedSupportCaption,
  TracingWrapper
} from 'layout/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ClosedOrderView = ({ orderInfo = {} }) => {
  return (
    <TracingWrapper>
      <MapViewMainContainer>
        {/* Warning Icon */}
        <ClosedIconBox>
          <WarningIcon 
            sx={{ 
              fontSize: 60, 
              color: 'white',
            }} 
          />
        </ClosedIconBox>

        {/* Title */}
        <ClosedTitle variant="h3" sx={{ color: '#FF6B35' }}>
         Order Issue
        </ClosedTitle>

        {/* Status Card */}
        <ClosedStatusCard>
          {orderInfo?.rejectedReason && (
            <ClosedStatusLabel variant="h6" sx={{ color: '#FF6B35' }}>
              {orderInfo?.rejectedReason}
            </ClosedStatusLabel>
          )}
        
          <ClosedStatusText variant="body1">
            There was an issue with your order. Please connect to the restaurant for updates and assistance.
          </ClosedStatusText>
        </ClosedStatusCard>

        {/* Support Card */}
        <ClosedSupportCard>
          <MapViewSupportHeader>
            <SupportAgentIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            <ClosedSupportTitle variant="subtitle2">
              Contact Restaurant
            </ClosedSupportTitle>
          </MapViewSupportHeader>
          
          <ClosedSupportDescription variant="body2">
            We recommend contacting the restaurant directly for order updates and resolution. Our support team is also available to assist you.
          </ClosedSupportDescription>

          <MapViewSupportList>
            <MapViewSupportItem>
              <StorefrontIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
              <ClosedSupportCaption variant="caption">
                Contact restaurant for order updates
              </ClosedSupportCaption>
            </MapViewSupportItem>
            <MapViewSupportItem>
              <PhoneIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
              <ClosedSupportCaption variant="caption">
                24/7 Customer Support Available
              </ClosedSupportCaption>
            </MapViewSupportItem>
            <MapViewSupportItem>
              <RefreshIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
              <ClosedSupportCaption variant="caption">
                No charges applied for closed orders
              </ClosedSupportCaption>
            </MapViewSupportItem>
          </MapViewSupportList>
        </ClosedSupportCard>

        {/* Order Details Section */}
        {(orderInfo?.number || orderInfo?.companyName) && (
          <MapViewIntegratedOrderDetails>
            <MapViewOrderDetailsTitle variant="h6">
              Order Details
            </MapViewOrderDetailsTitle>
            
            <MapViewOrderDetailsContainer>
              {orderInfo?.number && (
                <OrderInfoRow>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptIcon sx={{ color: '#FF6B35', fontSize: 18 }} />
                    <OrderInfoLabel>Order Number</OrderInfoLabel>
                  </Box>
                  <OrderInfoValue data-type="order-number">
                    #{orderInfo.number}
                  </OrderInfoValue>
                </OrderInfoRow>
              )}

              {orderInfo?.companyName && (
                <>
                  <Divider sx={{ my: 0.5 }} />
                  <OrderInfoRow>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <StorefrontIcon sx={{ color: '#FF6B35', fontSize: 18 }} />
                      <OrderInfoLabel>Restaurant</OrderInfoLabel>
                    </Box>
                    <OrderInfoValue>
                      {orderInfo.companyName}
                    </OrderInfoValue>
                  </OrderInfoRow>
                </>
              )}
              <Divider sx={{ my: 0.5 }} />
              <OrderInfoRow>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOnIcon sx={{ color: '#FF6B35', fontSize: 18 }} />
                  <OrderInfoLabel>Delivery Address</OrderInfoLabel>
                </Box>
                <OrderInfoValue sx={{ 
                  maxWidth: '300px',
                  fontSize: '16px'
                }}>
                  {orderInfo?.address || 'N/A'}
                </OrderInfoValue>
              </OrderInfoRow>
            </MapViewOrderDetailsContainer>
          </MapViewIntegratedOrderDetails>
        )}
      </MapViewMainContainer>
    </TracingWrapper>
  );
};

export default ClosedOrderView; 